import { getStandardButtonStyles } from "../../styles/standardButtons";
// frontend/aiAssistantModal.jsx
import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import * as Yup from "yup";
import { Formik, Form, Field, FastField, FieldArray } from "formik";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  Checkbox,
  Chip,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Tooltip
} from "@material-ui/core";
import {
  Visibility,
  VisibilityOff,
  ExpandMore,
  Add,
  ArrowForwardIos,
  ArrowDownward,
  ArrowUpward,
  Delete,
  Info,
  Settings,
  Timer,
  Chat,
  MicNone,
  Schedule as ScheduleIcon // [ANTIGRAVITY] Add Schedule Icon
} from "@material-ui/icons";
import { InputAdornment, Switch } from "@material-ui/core"; // [ANTIGRAVITY] Add Switch
import RemarketingTaskEditor from "../RemarketingTaskEditor"; // [ANTIGRAVITY] Import Task Editor
import AIKnowledgeModal from "../AIKnowledgeModal";
// Lista de modelos de IA soportados (Inicialmente vacía, se carga dinámicamente)
const defaultModels = [];
// Lista de vozes disponíveis para a IA
const availableVoices = [
  "texto",
  "pt-BR-FabioNeural",
  "pt-BR-FranciscaNeural",
  "pt-BR-AntonioNeural",
  "pt-BR-BrendaNeural",
  "pt-BR-DonatoNeural",
  "pt-BR-ElzaNeural",
  "pt-BR-GiovannaNeural",
  "pt-BR-HumbertoNeural",
  "pt-BR-JulioNeural",
  "pt-BR-LeilaNeural",
  "pt-BR-LeticiaNeural",
  "pt-BR-ManuelaNeural",
  "pt-BR-NicolauNeural",
  "pt-BR-ValerioNeural",
  "pt-BR-YaraNeural"
];
const availableProviders = [
  { value: "openai", label: "OpenAI", icon: "TbBrandOpenai" },
  { value: "gemini", label: "Gemini", icon: "TbSparkles" },
  { value: "deepseek", label: "DeepSeek", icon: "TbRobot" }
];
const getInitialState = () => ({
  name: "",
  prompt: "",
  model: "gpt-4o",
  voice: "texto",
  voiceKey: "",
  voiceRegion: "",
  maxTokens: 1000,
  temperature: 0.7,
  apiKey: "",
  maxMessages: 10,
  queueId: 0,
  // Campos para controle de fluxo
  flowMode: "permanent",
  maxInteractions: 5,
  completionTimeout: 10,
  continueKeywords: ["continuar", "próximo", "avançar"],
  objective: "",
  autoCompleteOnObjective: false,
  debounceTime: 0,
  provider: "openai",
  respondAudio: false,
  audioPlaceholder: i18n.t("flowBuilder.openai.defaultAudioPlaceholder") || "Lo siento, por ahora solo puedo procesar texto. ¿Podrías escribirme?",
  maxCharacters: 600, // [ANTIGRAVITY] Default 600 characters
  ragEnabled: true,
  ragThreshold: 0.7, // [ANTIGRAVITY] RAG similarity threshold
  ragMediaThreshold: 0.5, // [ANTIGRAVITY] Separated image RAG similarity threshold
  ragContextMessages: 3,
  handles: [],
  fallback: true
});
const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  sectionTitle: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  flowModeCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.default
  },
  temporarySettings: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : theme.palette.grey[50],
    borderRadius: theme.spacing(1),
    border: `1px dashed ${theme.palette.primary.light}`
  },
  keywordChip: {
    margin: theme.spacing(0.5),
  },
  helpText: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  accordion: {
    marginBottom: theme.spacing(1),
    "&:before": {
      display: "none",
    }
  },
  accordionSummary: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : theme.palette.grey[50],
    minHeight: 36,
    "&.Mui-expanded": {
      minHeight: 36,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "0px",
    }
  },
  accordionDetails: {
    padding: theme.spacing(0, 1, 1, 1),
    flexDirection: "column"
  },
  menuPaper: {
    minWidth: "500px !important",
    width: "fit-content !important",
    maxWidth: "800px !important"
  },
  warningBox: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: 4,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 152, 0, 0.1)' : '#fff3cd',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 152, 0, 0.5)' : '#ffeeba'}`,
    width: "100%"
  },
  warningText: {
    color: theme.palette.type === 'dark' ? '#ffb74d' : '#856404',
  },
  ragBox: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: 4,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(33, 150, 243, 0.1)' : '#e3f2fd',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(33, 150, 243, 0.5)' : '#90caf9'}`,
  },
  ragText: {
    color: theme.palette.type === 'dark' ? '#90caf9' : '#1565c0',
  },
  autoCloseBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 4,
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
  },
  finalTaskBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: '12px',
    position: 'relative',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(211, 47, 47, 0.05)' : '#fff0f5',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 107, 107, 1)' : '#f48fb1'}`,
    boxShadow: theme.palette.type === 'dark' ? '0 0 25px rgba(255, 107, 107, 0.9), inset 0 0 15px rgba(255, 107, 107, 0.3)' : 'none',
  },
  finalTaskTitle: {
    color: theme.palette.type === 'dark' ? '#f48fb1' : '#c2185b',
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
  },
  finalTaskDesc: {
    marginBottom: '20px',
    color: theme.palette.type === 'dark' ? '#f48fb1' : '#880e4f',
    fontSize: '0.8rem',
  },
  inputBackground: {
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.paper : '#fff',
  },
  textareaScrollbar: {
    resize: "vertical",
    minHeight: "80px",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.type === 'dark' ? '#555' : '#ccc',
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    }
  }
}));
// Esquema de validação para Asistente IA
const OpenAiSchema = Yup.object().shape({
  name: Yup.string()
    .min(5, i18n.t("flowBuilder.ai.validation.tooShort") || "Muito curto!")
    .max(100, i18n.t("flowBuilder.ai.validation.tooLong") || "Muito longo!")
    .required(i18n.t("flowBuilder.ai.validation.required") || "Obrigatório"),
  prompt: Yup.string()
    .min(50, i18n.t("flowBuilder.ai.validation.tooShort") || "Muito curto!")
    .required(i18n.t("flowBuilder.ai.validation.promptRequired") || "Descreva o treinamento para Inteligência Artificial"),
  model: Yup.string()
    .required(i18n.t("flowBuilder.ai.validation.modelRequired") || "Informe o modelo"),
  maxTokens: Yup.number()
    .min(10, i18n.t("flowBuilder.ai.validation.tokensMin") || "Mínimo 10 tokens")
    .max(4000, i18n.t("flowBuilder.ai.validation.tokensMax") || "Máximo 4000 tokens")
    .required(i18n.t("flowBuilder.ai.validation.tokensRequired") || "Informe o número máximo de tokens"),
  temperature: Yup.number()
    .min(0, i18n.t("flowBuilder.ai.validation.tempMin") || "Mínimo 0")
    .max(2, i18n.t("flowBuilder.ai.validation.tempMax") || "Máximo 2")
    .required(i18n.t("flowBuilder.ai.validation.tempRequired") || "Informe a temperatura"),
  apiKey: Yup.string(),
  maxMessages: Yup.number()
    .min(1, i18n.t("flowBuilder.ai.validation.messagesMin") || "Mínimo 1 mensagem")
    .max(100, i18n.t("flowBuilder.ai.validation.messagesMax") || "Máximo 100 mensagens")
    .required(i18n.t("flowBuilder.ai.validation.messagesRequired") || "Informe o número máximo de mensagens"),
  voice: Yup.string().required(i18n.t("flowBuilder.ai.validation.voiceRequired") || "Informe o modo para Voz"),
  voiceKey: Yup.string().when("voice", {
    is: (voice) => voice !== "texto",
    then: Yup.string().required(i18n.t("flowBuilder.ai.validation.voiceKeyRequired") || "Voice Key é obrigatória para síntese de voz"),
    otherwise: Yup.string().notRequired()
  }),
  voiceRegion: Yup.string().when("voice", {
    is: (voice) => voice !== "texto",
    then: Yup.string().required(i18n.t("flowBuilder.ai.validation.voiceRegionRequired") || "Voice Region é obrigatória para síntese de voz"),
    otherwise: Yup.string().notRequired()
  }),
  flowMode: Yup.string()
    .oneOf(["permanent", "temporary"], i18n.t("flowBuilder.ai.validation.flowModeInvalid") || "Modo de fluxo inválido")
    .required(i18n.t("flowBuilder.ai.validation.flowModeRequired") || "Selecione o modo de fluxo"),
  maxInteractions: Yup.number().when("flowMode", {
    is: "temporary",
    then: Yup.number()
      .min(1, i18n.t("flowBuilder.ai.validation.interactionsMin") || "Mínimo 1 interação")
      .max(50, i18n.t("flowBuilder.ai.validation.interactionsMax") || "Máximo 50 interações")
      .nullable(),
    otherwise: Yup.number().nullable()
  }),
  completionTimeout: Yup.number().when("flowMode", {
    is: "temporary",
    then: Yup.number()
      .min(1, i18n.t("flowBuilder.ai.validation.timeoutMin") || "Mínimo 1 minuto")
      .max(60, i18n.t("flowBuilder.ai.validation.timeoutMax") || "Máximo 60 minutos")
      .nullable(),
    otherwise: Yup.number().nullable()
  }),
  continueKeywords: Yup.array().when("flowMode", {
    is: "temporary",
    then: Yup.array()
      .of(Yup.string().required(i18n.t("flowBuilder.ai.validation.keywordEmpty") || "Palavra-chave não pode estar vazia"))
      .min(1, i18n.t("flowBuilder.ai.validation.keywordRequired") || "Pelo menos uma palavra-chave é obrigatória no modo temporário"),
    otherwise: Yup.array()
  }),
  objective: Yup.string().when(["flowMode", "autoCompleteOnObjective"], {
    is: (flowMode, autoComplete) => flowMode === "temporary" && autoComplete,
    then: Yup.string().required(i18n.t("flowBuilder.ai.validation.objectiveRequired") || "Objetivo é obrigatório quando auto completar está ativo"),
    otherwise: Yup.string()
  }),
  debounceTime: Yup.number()
    .min(0, i18n.t("flowBuilder.ai.validation.debounceMin") || "Mínimo 0 segundos")
    .max(60, i18n.t("flowBuilder.ai.validation.debounceMax") || "Máximo 60 segundos")
    .required(i18n.t("flowBuilder.ai.validation.debounceRequired") || "Informe o tempo de espera"),
  provider: Yup.string().required(i18n.t("flowBuilder.ai.validation.providerRequired") || "Selecione o proveedor"),
  respondAudio: Yup.boolean(),
  audioPlaceholder: Yup.string().when("respondAudio", {
    is: (val) => val === false,
    then: Yup.string().required(i18n.t("flowBuilder.ai.validation.audioPlaceholderRequired") || "Informe o mensaje de cortesía"),
    otherwise: Yup.string().notRequired()
  }),
  outputVariableName: Yup.string(),
  handles: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("El nombre del disparador es obligatorio"),
      label: Yup.string().required("La etiqueta es obligatoria"),
      // [ANTIGRAVITY] Auto-close configuration fields
      cancelRemarketing: Yup.boolean(),
      immediateMessage: Yup.string(),
      autoCloseEnabled: Yup.boolean(),
      autoCloseDelay: Yup.number().min(1).max(1440), // 1 min to 24 hours
      autoCloseMessage: Yup.string()
    })
  )
});
const FlowBuilderOpenAIModal = ({ open, onSave, data, onUpdate, flowId, close }) => {
  const classes = useStyles();
  const theme = useTheme();
  const primaryColor = theme?.palette?.primary?.main || localStorage.getItem("primaryColorLight") || "#10B981";
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);
  const [showApiKey, setShowApiKey] = useState(false);
  const [integration, setIntegration] = useState(getInitialState());
  const [labels, setLabels] = useState({
    title: i18n.t("flowBuilder.openai.addTitle") || "Configurar IA",
    btn: i18n.t("common.add") || "Adicionar",
  });
  const [newKeyword, setNewKeyword] = useState("");
  const [models, setModels] = useState(defaultModels);
  const [loadingModels, setLoadingModels] = useState(false);
  // [ANTIGRAVITY] Remarketing State
  const [expandedPanel, setExpandedPanel] = useState("routing");
  const [remarketingEnabled, setRemarketingEnabled] = useState(false);
  const [remarketingTasks, setRemarketingTasks] = useState([]);
  const [finalTaskEnabled, setFinalTaskEnabled] = useState(true);
  const [finalTaskTime, setFinalTaskTime] = useState(20);
  const [finalTaskUnit, setFinalTaskUnit] = useState("minutes");
  const [finalTaskMessage, setFinalTaskMessage] = useState("");
  const [modalKnowledgeOpen, setModalKnowledgeOpen] = useState(false);
  const remarketingEditorRef = useRef(null);
  const handleFetchModels = async (apiKeyProp, providerProp) => {
    setLoadingModels(true);
    try {
      const { data } = await api.post("/openai/models", {
        apiKey: apiKeyProp,
        provider: providerProp // Usar el provider pasado desde el form
      });
      if (Array.isArray(data) && data.length > 0) {
        setModels(data);
        toast.success(i18n.t("flowBuilder.openai.modelsLoaded", "Modelos cargados con éxito"));
      } else {
        toast.warning(i18n.t("flowBuilder.openai.noModelsCallback", "No se encontraron modelos compatibles."));
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.error || err.message;
      toast.error(`${i18n.t("flowBuilder.openai.modelsError", "Error al buscar modelos.")} (${errorMsg})`);
    }
    setLoadingModels(false);
  };
  useEffect(() => {
    if (open === "edit") {
      setLabels({
        title: i18n.t("flowBuilder.openai.editTitle") || "Editar OpenAI do fluxo",
        btn: i18n.t("common.save"),
      });
      const typebotIntegration = data?.data?.typebotIntegration || {};
      const nodeData = data?.data || {};
      const defaultState = getInitialState();
      setIntegration({
        ...defaultState,
        ...typebotIntegration,
        // [ANTIGRAVITY] Fix: Load Name and OutputVariable from root data
        name: nodeData.name || typebotIntegration.name || defaultState.name,
        outputVariableName: nodeData.outputVariableName || typebotIntegration.outputVariableName || defaultState.outputVariableName,
        model: typebotIntegration.model || "gpt-4o",
        flowMode: typebotIntegration.flowMode || "permanent",
        continueKeywords: typebotIntegration.continueKeywords || ["continuar", "próximo", "avançar"],
        maxInteractions: typebotIntegration.maxInteractions || 5,
        completionTimeout: typebotIntegration.completionTimeout || 10,
        objective: typebotIntegration.objective || "",
        autoCompleteOnObjective: typebotIntegration.autoCompleteOnObjective || false,
        debounceTime: typebotIntegration.debounceTime || 0,
        ragEnabled: typebotIntegration.ragEnabled !== undefined ? typebotIntegration.ragEnabled : true,
        ragThreshold: typebotIntegration.ragThreshold || 0.7, // [ANTIGRAVITY] Load RAG threshold
        ragMediaThreshold: typebotIntegration.ragMediaThreshold || 0.5, // [ANTIGRAVITY] Load image RAG threshold
        ragContextMessages: typebotIntegration.ragContextMessages || 3, // [ANTIGRAVITY] Load RAG Context Messages
        maxCharacters: typebotIntegration.maxCharacters || 600, // [ANTIGRAVITY] Load Max Characters
        handles: typebotIntegration.handles || defaultState.handles
      });
      if (typebotIntegration.model) {
        setModels([typebotIntegration.model]);
      }
      // [ANTIGRAVITY] Load Remarketing Data
      // For new nodes (open === "create" or no data), force remarketingEnabled to true
      // For existing nodes, use the saved value OR true if it was undefined (migration strategy)
      const isNewNode = open === "create" || !typebotIntegration.model;
      setRemarketingEnabled(isNewNode ? true : (typebotIntegration.remarketingEnabled !== false));
      // Separar Tareas Manuales de Final
      let tasks = typebotIntegration.remarketingTasks || [];
      const lastTask = tasks.length > 0 ? tasks[tasks.length - 1] : null;
      if (lastTask && (lastTask.isFinalTask || lastTask.closeTicket)) {
        const defaultMsg = "Estuve atento a tu respuesta. Tal vez en estos momentos estés ocupad@, pero, descuida, puedes volver a escribirnos cuando te encuentres disponible para continuar con tu atención. ¡Te esperamos!";
        let msg = lastTask.content && lastTask.content[0] ? lastTask.content[0].value : "";
        // [ANTIGRAVITY] Fix: If msg is the raw translation key or empty, use default
        if (!msg || msg === "flowBuilder.remarketing.defaultFinalMsg") {
          msg = defaultMsg;
        }
        setFinalTaskEnabled(true);
        setFinalTaskTime(lastTask.waitTime || 20);
        setFinalTaskUnit(lastTask.waitUnit || "minutes");
        setFinalTaskMessage(msg);
        setRemarketingTasks(tasks.slice(0, tasks.length - 1));
      } else {
        setRemarketingTasks(tasks);
        setFinalTaskEnabled(false);
        setFinalTaskTime(20);
        setFinalTaskUnit("minutes");
        setFinalTaskMessage(i18n.t("flowBuilder.remarketing.defaultFinalMsg") || "Estuve atento a tu respuesta. Tal vez en estos momentos estés ocupad@, pero, descuida, puedes volver a escribirnos cuando te encuentres disponible para continuar con tu atención. ¡Te esperamos!");
      }
    } else if (open === "create") {
      setLabels({
        title: i18n.t("flowBuilder.openai.addTitle") || "Adicionar OpenAI ao fluxo",
        btn: i18n.t("common.add") || "Adicionar",
      });
      setIntegration(getInitialState());
      // [ANTIGRAVITY] Defaults for New Node
      setRemarketingEnabled(true); // Suggest enabling it
      setRemarketingTasks([]);
      setFinalTaskEnabled(true);
      setFinalTaskTime(20);
      setFinalTaskUnit("minutes");
      setFinalTaskMessage(i18n.t("flowBuilder.remarketing.defaultFinalMsg") || "Estuve atento a tu respuesta. Tal vez en estos momentos estés ocupad@, pero, descuida, puedes volver a escribirnos cuando te encuentres disponible para continuar con tu atención. ¡Te esperamos!");
    }
    return () => {
      isMounted.current = false;
    };
  }, [open, data]);
  const handleClose = () => {
    setNewKeyword("");
    // Check pending edits
    if (remarketingEditorRef.current && remarketingEditorRef.current.hasPendingChanges()) {
      if (!window.confirm("Tienes cambios sin guardar en el editor de tareas. ¿Descartar?")) return;
    }
    close(null);
  };
  const handleSavePrompt = (values, { setSubmitting }) => {
    // [ANTIGRAVITY] Prevent saving if there's an unsaved task in the editor
    if (remarketingEditorRef.current && remarketingEditorRef.current.hasPendingChanges()) {
      toast.warning("Tienes una tarea de remarketing sin guardar. Por favor, agrégala (o bórrala) antes de guardar el nodo.");
      return;
    }
    // [ANTIGRAVITY] Construct Final Remarketing Tasks
    let allTasks = [...remarketingTasks];
    if (remarketingEnabled && finalTaskEnabled) {
      const finalTaskObj = {
        id: Date.now() + 999123,
        isFinalTask: true,
        isLastTask: true,
        waitTime: Number(finalTaskTime),
        waitUnit: finalTaskUnit || 'minutes',
        variable: `final_closure_${Date.now()}`,
        content: [
          { type: 'text', value: finalTaskMessage || i18n.t("flowBuilder.remarketing.defaultFinalMsg") || "Cerrando ticket por inactividad. ¡Gracias!" }
        ],
        order: allTasks.length + 1,
        closeTicket: true
      };
      allTasks.push(finalTaskObj);
    }
    const promptData = {
      ...values,
      // Garantir que campos do modo temporário sejam nulos se modo for permanente
      maxInteractions: values.flowMode === "temporary" ? values.maxInteractions : null,
      completionTimeout: values.flowMode === "temporary" ? values.completionTimeout : null,
      continueKeywords: values.flowMode === "temporary" ? values.continueKeywords : [],
      objective: values.flowMode === "temporary" ? values.objective : "",
      autoCompleteOnObjective: values.flowMode === "temporary" ? values.autoCompleteOnObjective : false,
      provider: values.provider,
      remarketingEnabled: remarketingEnabled,
      remarketingTasks: allTasks
    };
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          // [ANTIGRAVITY] Fix: Keep existing data and update specific fields
          ...data.data,
          name: promptData.name,
          outputVariableName: promptData.outputVariableName,
          typebotIntegration: promptData
        },
      });
    } else if (open === "create") {
      promptData.projectName = promptData.name;
      onSave({
        // [ANTIGRAVITY] Fix: Pass root fields + integration data
        name: promptData.name,
        outputVariableName: promptData.outputVariableName,
        typebotIntegration: promptData,
      });
    }
    handleClose();
    setSubmitting(false);
  };
  const addKeyword = (arrayHelpers, keyword) => {
    if (keyword.trim() && !integration.continueKeywords.includes(keyword.trim())) {
      arrayHelpers.push(keyword.trim());
      setNewKeyword("");
    }
  };
  const removeKeyword = (arrayHelpers, index) => {
    arrayHelpers.remove(index);
  };
  const getModelDisplayName = (model) => {
    const modelNames = {
      "gpt-3.5-turbo": "GPT 3.5 Turbo",
      "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (1106)",
      "gpt-3.5-turbo-16k": "GPT 3.5 Turbo 16K",
      "gpt-4": "GPT 4",
      "gpt-4-turbo": "GPT 4 Turbo",
      "gpt-4o": "GPT 4o",
      "gpt-4o-mini": "GPT 4o Mini"
    };
    return modelNames[model] || model;
  };
  const getVoiceDisplayName = (voice) => {
    if (voice === "texto") return "Apenas Texto";
    return voice.replace("pt-BR-", "").replace("Neural", "");
  };
  return (
    <div className={classes.root}>
      <Dialog
        open={open === "edit" || open === "create"}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
          }
        }}
      >
        <DialogContent dividers style={{ padding: 0, display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden" }}>
        <Box p={3} pb={1} display="flex" flexDirection="column" style={{ flexShrink: 0 }}>
          <Typography variant="h6" id="form-dialog-title" style={{ fontWeight: 'bold' }}>
            {labels.title}
          </Typography>
        </Box>
        <Formik
          initialValues={integration}
          enableReinitialize={true}
          validationSchema={OpenAiSchema}
          onSubmit={handleSavePrompt}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>
              <Box style={{ overflowY: "auto", overflowX: "hidden", flex: 1, minHeight: 0, padding: "0 24px 16px 24px" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={7}>
                    {/* CONFIGURAÇÕES BÁSICAS */}
                <Accordion className={classes.accordion} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <Settings />
                      {i18n.t("flowBuilder.openai.basicSettings") || "Configurações Básicas"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    <div className={classes.multFieldLine}>
                      <Field
                        as={TextField}
                        label={i18n.t("flowBuilder.ai.form.name") || "Nome do Assistente"}
                        name="name"
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        required
                        size="small"
                        style={{ flex: 1 }}
                      />
                    </div>
                    <FastField
                      as={TextField}
                      label={i18n.t("flowBuilder.ai.form.prompt") || "Prompt do Sistema"}
                      name="prompt"
                      error={touched.prompt && Boolean(errors.prompt)}
                      helperText={touched.prompt && errors.prompt}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      rows={4}
                      rowsMax={4}
                      multiline
                      placeholder={i18n.t("flowBuilder.ai.form.promptPlaceholder") || "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder..."}
                      inputProps={{
                        className: classes.textareaScrollbar
                      }}
                    />
                    <div className={classes.multFieldLine}>
                      <Field
                        as={TextField}
                        label={i18n.t("flowBuilder.ai.form.temperature") || "Temperatura"}
                        name="temperature"
                        error={touched.temperature && Boolean(errors.temperature)}
                        helperText={(touched.temperature && errors.temperature) || (i18n.t("flowBuilder.ai.form.temperatureHelper") || "0 = conservador, 2 = criativo")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        type="number"
                        inputProps={{
                          step: "any",
                          min: "0",
                          max: "2",
                        }}
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("flowBuilder.ai.form.maxTokens") || "Max Tokens"}
                        name="maxTokens"
                        error={touched.maxTokens && Boolean(errors.maxTokens)}
                        helperText={(touched.maxTokens && errors.maxTokens) || (i18n.t("flowBuilder.ai.form.maxTokensHelper") || "Tamanho máximo da resposta")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        type="number"
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("flowBuilder.ai.form.maxMessages") || "Max Mensagens"}
                        name="maxMessages"
                        error={touched.maxMessages && Boolean(errors.maxMessages)}
                        helperText={(touched.maxMessages && errors.maxMessages) || (i18n.t("flowBuilder.ai.form.maxMessagesHelper") || "Histórico de contexto")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        type="number"
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
                {/* GESTIÓN DE AUDIOS */}
                <Accordion className={classes.accordion} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <MicNone />
                      {i18n.t("flowBuilder.ai.form.audioTitle") || "Gestión de Audios"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    <Box className={classes.warningBox}>
                      <Typography variant="caption" className={classes.warningText} style={{ fontWeight: 'bold' }}>
                        {i18n.t("flowBuilder.ai.form.audioWarningTitle") || "⚠️ NOTA IMPORTANTE SOBRE LOS AUDIOS:"}
                      </Typography>
                      <Typography variant="caption" display="block" className={classes.warningText}>
                        {i18n.t("flowBuilder.ai.form.audioWarningText") || "La transcripción de audios utiliza Whisper de OpenAI por debajo. Si esta desactivada esta opción, no se podra responder con texto a los audios. Ten en cuenta que esta funcionalidad genera un consumo y cobro por su uso."}
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.respondAudio}
                          onChange={(e) => setFieldValue("respondAudio", e.target.checked)}
                          name="respondAudio"
                          disabled={values.provider !== "openai"}
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body2">
                            {i18n.t("flowBuilder.ai.form.respondAudio") || "Contestar audios"}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {values.provider !== "openai"
                              ? i18n.t("flowBuilder.ai.form.respondAudioGeminiDesc") || "Solo disponible para OpenAI (Whisper)"
                              : i18n.t("flowBuilder.ai.form.respondAudioDesc") || "Activa el reconocimiento de voz para mensajes de audio"}
                          </Typography>
                        </Box>
                      }
                    />
                    {!values.respondAudio && (
                      <FastField
                        as={TextField}
                        label={i18n.t("flowBuilder.ai.form.audioPlaceholder") || "Mensaje de cortesía para audios"}
                        name="audioPlaceholder"
                        error={touched.audioPlaceholder && Boolean(errors.audioPlaceholder)}
                        helperText={(touched.audioPlaceholder && errors.audioPlaceholder) || (i18n.t("flowBuilder.ai.form.audioPlaceholderHelper") || "Este mensaje se enviará cuando el bot reciba un audio")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        multiline
                        rows={2}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
                {/* CONFIGURAÇÕES DE VOZ */}
                <Accordion className={classes.accordion}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <Chat />
                      {i18n.t("flowBuilder.openai.voiceSettings") || "Configurações de Voz (Opcional)"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    <FormControl
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      error={touched.voice && Boolean(errors.voice)}
                    >
                      <InputLabel>{i18n.t("flowBuilder.ai.form.voiceType") || "Tipo de Resposta"}</InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("flowBuilder.ai.form.voiceType") || "Tipo de Resposta"}
                        name="voice"
                      >
                        {availableVoices.map((voice) => (
                          <MenuItem key={voice} value={voice}>
                            {getVoiceDisplayName(voice)}
                          </MenuItem>
                        ))}
                      </Field>
                      {touched.voice && errors.voice && (
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {errors.voice}
                        </div>
                      )}
                    </FormControl>
                    {values.voice !== "texto" && (
                      <div className={classes.multFieldLine}>
                        <Field
                          as={TextField}
                          label={i18n.t("flowBuilder.ai.form.voiceKey") || "Voice Key (Azure)"}
                          name="voiceKey"
                          error={touched.voiceKey && Boolean(errors.voiceKey)}
                          helperText={touched.voiceKey && errors.voiceKey}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          placeholder="Chave do Azure Speech Service"
                        />
                        <Field
                          as={TextField}
                          label={i18n.t("flowBuilder.ai.form.voiceRegion") || "Voice Region (Azure)"}
                          name="voiceRegion"
                          error={touched.voiceRegion && Boolean(errors.voiceRegion)}
                          helperText={touched.voiceRegion && errors.voiceRegion}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          placeholder="ex: brazilsouth"
                        />
                      </div>
                    )}
                  </AccordionDetails>
                </Accordion>
                {/* COMPORTAMENTO DO FLUXO (SIMPLIFICADO) */}
                <Accordion className={classes.accordion} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <Timer />
                      {i18n.t("flowBuilder.ai.form.flowBehavior") || "Comportamento do Fluxo"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    {/* VARIABLE OCULTA: MODO PERMANENTE (HYBRID) */}
                    {/* Forzamos que sea siempre "permanent" para que active la lógica Híbrida del Backend */}
                    <Field type="hidden" name="flowMode" value="permanent" />
                    {/* NOVO CAMPO: TEMPO DE ESPERA (DEBOUNCE) */}
                    <div className={classes.multFieldLine}>
                      <Field
                        as={TextField}
                        label={i18n.t("flowBuilder.openai.debounceTime") || "Tiempo de Espera (Buffer)"}
                        name="debounceTime"
                        type="number"
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        helperText={i18n.t("flowBuilder.openai.debounceTimeHelper") || "Segundos a esperar para agrupar mensajes (0 = Respuesta Inmediata)"}
                        error={touched.debounceTime && Boolean(errors.debounceTime)}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">seg</InputAdornment>,
                        }}
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("flowBuilder.openai.outputVariableName") || "Nombre Variable de Salida"}
                        name="outputVariableName"
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        helperText={i18n.t("flowBuilder.openai.outputVariableNameHelper") || "Nombre de la variable donde se guardará la acción (Ej: ai_action, resultado_venta)"}
                        error={touched.outputVariableName && Boolean(errors.outputVariableName)}
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
                {/* BASE DE CONOCIMIENTO (RAG) */}
                <Accordion className={classes.accordion} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <Info />
                      {i18n.t("flowBuilder.ai.form.ragTitle") || "Base de Conocimiento (RAG)"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.ragEnabled}
                          onChange={(e) => setFieldValue("ragEnabled", e.target.checked)}
                          color="primary"
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body2">
                            {i18n.t("flowBuilder.ai.form.ragEnabled") || "Usar Base de Conocimiento"}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {i18n.t("flowBuilder.ai.form.ragEnabledDesc") || "Permite al asistente buscar información en el catálogo de productos cargado."}
                          </Typography>
                        </Box>
                      }
                    />
                    {values.ragEnabled && (
                      <Box className={classes.ragBox}>
                        <Typography variant="caption" className={classes.ragTitle}>
                          {i18n.t("flowBuilder.ai.form.ragActiveSystem") || "✨ Sistema RAG Activo:"}
                        </Typography>
                        <Typography variant="caption" display="block" className={classes.ragText}>
                          {i18n.t("flowBuilder.ai.form.ragActiveSystemDesc") || "El asistente recuperará automáticamente los datos más relevantes de tu catálogo para responder al usuario."}
                        </Typography>
                        {/* [ANTIGRAVITY] RAG Threshold Configuration */}
                        <Box mt={1.5}>
                          <TextField
                            fullWidth
                            label={i18n.t("flowBuilder.ai.form.ragThreshold") || "Umbral de Similitud (Threshold)"}
                            type="number"
                            size="small"
                            variant="outlined"
                            margin="dense"
                            value={values.ragThreshold}
                            onChange={(e) => setFieldValue("ragThreshold", parseFloat(e.target.value))}
                            inputProps={{ min: 0.1, max: 1.0, step: 0.1 }}
                            helperText={i18n.t("flowBuilder.ai.form.ragThresholdHelper") || "Rango: 0.1 - 1.0. Menor = más resultados. Recomendado: 0.5-0.7"}
                          />
                        </Box>
                        {/* [ANTIGRAVITY] RAG Media Threshold */}
                        <Box mt={0.5}>
                          <TextField
                            fullWidth
                            label={i18n.t("flowBuilder.ai.form.ragMediaThreshold") || "Umbral Similitud Multimedia"}
                            type="number"
                            size="small"
                            variant="outlined"
                            margin="dense"
                            value={values.ragMediaThreshold}
                            onChange={(e) => setFieldValue("ragMediaThreshold", parseFloat(e.target.value))}
                            inputProps={{ min: 0.1, max: 1.0, step: 0.1 }}
                            helperText={i18n.t("flowBuilder.ai.form.ragMediaThresholdHelper") || "Rango: 0.1 - 1.0. Sugerido: 0.5-0.8 (Más estricto)"}
                          />
                        </Box>
                        {/* [ANTIGRAVITY] RAG Context Messages Configuration */}
                        <Box mt={0.5}>
                          <TextField
                            fullWidth
                            label={i18n.t("flowBuilder.ai.form.ragContextMessages") || "Mensajes Contexto RAG"}
                            type="number"
                            size="small"
                            variant="outlined"
                            margin="dense"
                            value={values.ragContextMessages}
                            onChange={(e) => setFieldValue("ragContextMessages", parseInt(e.target.value))}
                            inputProps={{ min: 0, max: 20 }}
                            helperText={i18n.t("flowBuilder.ai.form.ragContextMessagesHelper") || "Contexto previo para búsqueda RAG (Sugerido: 3)"}
                          />
                        </Box>
                        {/* [ANTIGRAVITY] Max Characters Configuration */}
                        <Box mt={0.5}>
                          <TextField
                            fullWidth
                            label={i18n.t("flowBuilder.ai.form.maxCharacters") || "Máximo de Caracteres"}
                            type="number"
                            size="small"
                            variant="outlined"
                            margin="dense"
                            value={values.maxCharacters}
                            onChange={(e) => setFieldValue("maxCharacters", parseInt(e.target.value))}
                            inputProps={{ min: 50, max: 4000 }}
                            helperText={i18n.t("flowBuilder.ai.form.maxCharactersHelper") || "Límite para evitar verbosidad (Ej: 300)"}
                          />
                        </Box>
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          fullWidth
                          style={{ marginTop: 8 }}
                          onClick={() => setModalKnowledgeOpen(true)}
                        >
                          {i18n.t("flowBuilder.ai.form.configureKnowledgeBase") || "Configurar Base de Conocimiento"}
                        </Button>
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
                </Grid>
                  <Grid item xs={12} md={5}>
                    {/* SALIDAS TRANSACCIONALES (HANDLES) */}
                <Accordion className={classes.accordion} expanded={expandedPanel === "routing"} onChange={(e, isExpanded) => setExpandedPanel(isExpanded ? "routing" : false)}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <ArrowForwardIos style={{ fontSize: '18px' }} />
                      {i18n.t("flowBuilder.ai.form.routingTitle") || "Ruteo Semántico (Caminos)"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    <Typography variant="caption" color="textSecondary" style={{ marginBottom: 10, whiteSpace: 'pre-line', display: 'block' }}>
                      {i18n.t("flowBuilder.ai.form.routingDesc") || "La IA comparará la intención del cliente con cada camino semántico. El primero que coincida definirá el siguiente paso."}
                    </Typography>
                    <Box mb={2} p={1} bgcolor={`${primaryColor}1A`} borderRadius={4} border={`1px solid ${primaryColor}4D`}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={values.fallback !== false}
                            onChange={(e) => setFieldValue("fallback", e.target.checked)}
                            color="primary"
                            size="small"
                          />
                        }
                        label={<Typography variant="body2" style={{ fontWeight: 600, color: primaryColor }}>{i18n.t("flowBuilder.ai.form.fallbackDesc") || "Responder si no coincide (fallback de IA)"}</Typography>}
                      />
                      <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginLeft: 30 }}>
                        Si está activo, la IA responderá la pregunta del cliente en caso de que ninguna intención coincida. Si está inactivo, la IA solo servirá como enrutador y no contestará nada (útil para flujos estrictos).
                      </Typography>
                    </Box>
                    <FieldArray name="handles">
                      {({ push, remove, swap }) => (
                        <Box>
                          {values.handles.map((handle, index) => (
                            <Box key={index} mb={2} p={2} border="1px solid rgba(128, 128, 128, 0.3)" borderRadius={4}>
                              <Box display="flex" flexDirection="column" gap={1}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                                  <Chip
                                    label={i18n.t("flowBuilder.ai.form.routeNumber", { number: index + 1 }) || `Ruta #${index + 1}`}
                                    size="small"
                                    style={{
                                      height: 22,
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      backgroundColor: `${primaryColor}22`,
                                      color: primaryColor,
                                      border: `1px solid ${primaryColor}55`,
                                    }}
                                  />
                                  <Box display="flex" alignItems="center">
                                    <Tooltip title={i18n.t("flowBuilder.ai.form.moveUp") || "Mover hacia arriba"}>
                                      <span>
                                        <IconButton
                                          size="small"
                                          disabled={index === 0}
                                          onClick={() => swap(index, index - 1)}
                                          style={{ padding: 4, marginRight: 2 }}
                                        >
                                          <ArrowUpward fontSize="small" style={{ fontSize: 18 }} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    <Tooltip title={i18n.t("flowBuilder.ai.form.moveDown") || "Mover hacia abajo"}>
                                      <span>
                                        <IconButton
                                          size="small"
                                          disabled={index === values.handles.length - 1}
                                          onClick={() => swap(index, index + 1)}
                                          style={{ padding: 4, marginRight: 4 }}
                                        >
                                          <ArrowDownward fontSize="small" style={{ fontSize: 18 }} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    <Tooltip title={i18n.t("flowBuilder.ai.form.deleteRoute") || "Eliminar ruta"}>
                                      <IconButton
                                        size="small"
                                        onClick={() => remove(index)}
                                        style={{ padding: 4 }}
                                      >
                                        <Delete color="error" style={{ fontSize: 18 }} />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Field
                                    as={TextField}
                                    label={i18n.t("flowBuilder.ai.form.triggerName") || "Nombre (Trigger)"}
                                    name={`handles.${index}.name`}
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    placeholder={i18n.t("flowBuilder.ai.form.triggerNamePlaceholder") || "ej: pago, agendar, soporte"}
                                  />
                                  <Field
                                    as={TextField}
                                    label={i18n.t("flowBuilder.ai.form.uiLabel") || "Etiqueta (UI)"}
                                    name={`handles.${index}.label`}
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    placeholder={i18n.t("flowBuilder.ai.form.uiLabelPlaceholder") || "ej: Pagos / Comprobantes"}
                                  />
                                </Box>
                                <Box>
                                  <Field
                                    as={TextField}
                                    label={i18n.t("flowBuilder.openAi.form.intentWords") || "Palabras guía (Intención Semántica)"}
                                    name={`handles.${index}.keywords`}
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    inputProps={{
                                      style: { resize: "vertical" }
                                    }}
                                    placeholder="ej: comprar, precio, quiero hacer la compra"
                                    helperText={i18n.t("flowBuilder.openAi.form.intentHelper") || "Escribe las palabras o frases que el cliente podría decir para activar esta intención (separadas por comas)"}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          ))}
                          <Button
                            startIcon={<Add />}
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => push({
                              name: "",
                              label: "",
                              keywords: ""
                            })}
                            style={{ marginTop: 8 }}
                          >
                            {i18n.t("flowBuilder.ai.form.addOutput") || "Añadir Salida"}
                          </Button>
                        </Box>
                      )}
                    </FieldArray>
                  </AccordionDetails>
                </Accordion>
                {/* REMARKETING AUTOMÁTICO (AI NATIVE) */}
                <Accordion className={classes.accordion} expanded={expandedPanel === "remarketing"} onChange={(e, isExpanded) => setExpandedPanel(isExpanded ? "remarketing" : false)}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    className={classes.accordionSummary}
                  >
                    <Typography className={classes.sectionTitle}>
                      <ScheduleIcon /> {/* Necesitas importar ScheduleIcon */}
                      {i18n.t("flowBuilder.remarketing.title") || "Reactivación Automática (AI Native)"}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetails}>
                    <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" mb={2}>
                      <Box display="flex" alignItems="center">
                        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                          {i18n.t("flowBuilder.remarketing.enableLabel") || "Activar Seguimiento"}
                        </Typography>
                      </Box>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={remarketingEnabled}
                            onChange={(e) => setRemarketingEnabled(e.target.checked)}
                            name="remarketingEnabled"
                            color="primary"
                          />
                        }
                        label={
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="body1" component="span" style={{ fontWeight: 'bold' }}>
                              {i18n.t("flowBuilder.ai.form.enableRemarketing") || "Habilitar Remarketing y Auto-Cierre"}
                            </Typography>
                          </div>
                        }
                      />
                    </Box>
                    {remarketingEnabled && (
                      <>
                        <Box mb={0.5}>
                          <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                            {i18n.t("flowBuilder.openai.remarketingHelp") || "Configura los mensajes de seguimiento que la IA enviará si el usuario deja de responder. La IA leerá el historial antes de hablar."}
                          </Typography>
                        </Box>
                        <RemarketingTaskEditor
                          ref={remarketingEditorRef}
                          tasks={remarketingTasks}
                          onChange={setRemarketingTasks}
                          maxTasks={30}
                          isAiNode={true} // [ANTIGRAVITY] Flag para indicar modo IA (Texto = Prompt)
                        />
                        {/* Tarea de Cierre Obligatoria */}
                        <Box style={{
                          marginTop: '24px',
                          padding: '16px',
                          backgroundColor: 'rgba(211, 47, 47, 0.05)',
                          borderRadius: '12px',
                          border: '1px solid rgba(255, 107, 107, 1)',
                          boxShadow: '0 0 25px rgba(255, 107, 107, 0.9), inset 0 0 15px rgba(255, 107, 107, 0.3)',
                          position: 'relative'
                        }}>
                          <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between" mb={1}>
                            <Box display="flex" flexDirection="row" alignItems="center">
                              <Typography variant="subtitle2" style={{ color: '#ff6b6b', fontWeight: 'bold', marginRight: '8px' }}>
                                {i18n.t("flowBuilder.remarketing.finalTaskTitle") || "🏁 Cierre Automático"}
                              </Typography>
                              <Chip label="Final" size="small" style={{ backgroundColor: '#ff6b6b', color: '#fff', fontWeight: 'bold' }} />
                            </Box>
                            <Switch
                              size="small"
                              checked={finalTaskEnabled}
                              onChange={(e) => setFinalTaskEnabled(e.target.checked)}
                              color="primary"
                            />
                          </Box>
                          {finalTaskEnabled && (
                            <>
                              <Typography variant="body2" style={{ color: '#ff6b6b', marginBottom: '16px', fontSize: '0.8rem', opacity: 0.9 }}>
                                {i18n.t("flowBuilder.remarketing.finalTaskDesc") || "Si no hay respuesta tras el último intento, el ticket se cerrará automáticamente."}
                              </Typography>
                          <Box display="flex" flexDirection="column" style={{ gap: '20px' }}>
                            <Box display="flex" flexDirection="row" alignItems="center" style={{ gap: '10px' }}>
                              <TextField
                                label={i18n.t("flowBuilder.remarketing.waitTime") || "Espera Final"}
                                type="number"
                                variant="outlined"
                                size="small"
                                value={finalTaskTime}
                                onChange={(e) => {
                                  let val = parseInt(e.target.value);
                                  if (val < 1) val = 1;
                                if (val > 360) val = 360;
                                  setFinalTaskTime(val);
                                }}
                                InputProps={{ inputProps: { min: 1, max: 360 } }}
                                style={{ width: '150px' }}
                              />
                              <TextField
                                select
                                SelectProps={{ MenuProps: { PaperProps: { style: { backgroundColor: "#424242", color: "white" } } } }}
                                label={i18n.t("flowBuilder.remarketing.waitUnit") || "Unidad"}
                                variant="outlined"
                                size="small"
                                value={finalTaskUnit}
                                onChange={(e) => setFinalTaskUnit(e.target.value)}
                                style={{ width: '150px' }}
                              >
                                <MenuItem value="minutes">{i18n.t("flowBuilder.remarketing.units.minutes") || "Minutos"}</MenuItem>
                                <MenuItem value="hours">{i18n.t("flowBuilder.remarketing.units.hours") || "Horas"}</MenuItem>
                                <MenuItem value="days">{i18n.t("flowBuilder.remarketing.units.days") || "Días"}</MenuItem>
                              </TextField>
                              <Typography variant="body2" style={{ fontWeight: 'bold' }}>{i18n.t("flowBuilder.remarketing.afterLastAction") || "después de la última acción."}</Typography>
                            </Box>
                            <Box display="flex" flexDirection="row" alignItems="center" style={{ width: '100%' }}>
                              <TextField
                                label={i18n.t("flowBuilder.remarketing.finalTaskMessageLabel") || "Mensaje de Cierre"}
                                type="text"
                                variant="outlined"
                                size="small"
                                fullWidth
                                multiline
                                maxRows={4}
                                value={finalTaskMessage}
                                onChange={(e) => setFinalTaskMessage(e.target.value)}
                              />
                            </Box>
                          </Box>
                            </>
                          )}
                        </Box>
                      </>
                    )}
                  </AccordionDetails>
                </Accordion>
                </Grid>
              </Grid>
              </Box>
              <Box p={2} display="flex" justifyContent="flex-end" style={{ borderTop: "1px solid rgba(128, 128, 128, 0.3)", flexShrink: 0, gap: 8 }}>
                <Button onClick={handleClose} className={classes.secondaryButton}>{i18n.t("common.cancel") || "Cancelar"}</Button>
                <Button type="submit" disabled={isSubmitting || (models.length === 0 && values.provider !== "gemini")} className={classes.applyButton}>{labels.btn}</Button>
              </Box>
            </Form>
          )}
        </Formik>
      </DialogContent></Dialog>
      <AIKnowledgeModal
        open={modalKnowledgeOpen}
        onClose={() => setModalKnowledgeOpen(false)}
        flowId={flowId}
      />
    </div >
  );
};
export default FlowBuilderOpenAIModal;
